import styled from '@emotion/styled';
import { Box, Card, CardContent, Skeleton } from '@mui/material';
import { Center, TitleLarge } from '@dh/styles';
import { Breakpoint } from '@dh/types';
import { shouldForwardProps } from '@dh/utils';

const CardContainer = styled(Card, shouldForwardProps)<{ breakpoint: Breakpoint }>`
    border: 1px solid ${({ theme }) => theme.colors.primary};
    border-radius: ${({ theme }) => theme.spacing(1)};
    cursor: pointer;
    position: relative;
    height: 483px;
    min-width: 260px;
    justify-content: flex-start;
    max-width: 421px;
`;

const CompanyCardContent = styled(CardContent)`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: -webkit-fill-available;
    gap: ${({ theme }) => theme.spacing(2)};
    padding-right: ${({ theme }) => theme.spacing(2)};
    padding-top: ${({ theme }) => theme.spacing(3)};
    & > :last-child {
        padding-bottom: ${({ theme }) => theme.spacing(2)};
    }
`;

const CompanyTitle = styled(TitleLarge)`
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;

    text-overflow: ellipsis;
    white-space: normal;
    width: inherit;
    color: ${({ theme }) => theme.colors.onPrimaryDark};
`;

const CompanyDescription = styled(Box)`
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    width: inherit;
    height: inherit;
`;

const PlaceholderImage = styled(Center)`
    height: 223px;
    background-color: ${({ theme }) => theme.colors.secondaryDark};
    > svg {
        height: 48px;
        width: 48px;
        color: ${({ theme }) => theme.colors.onSecondaryDark};
    }
`;

const LoadingCompanyCardContainer = styled(Box)`
    width: 100%;
    padding: ${({ theme }) => theme.spacing(2)};
`;

const SkeletonTagsContainer = styled(Box)`
    width: 85%;
    display: flex;
    flex-wrap: wrap;
    gap: ${({ theme }) => theme.spacing(1)};
`;

const StyledSkeletonTag = styled(Skeleton)`
    height: ${({ theme }) => theme.spacing(4)};
`;

export {
    CardContainer,
    CompanyCardContent,
    CompanyDescription,
    CompanyTitle,
    LoadingCompanyCardContainer,
    PlaceholderImage,
    SkeletonTagsContainer,
    StyledSkeletonTag
};
